import { Component, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { Faq } from 'src/app/_shared/bloque-faqs/_models/faq';
import { BloqueFaqsComponent } from 'src/app/_shared/bloque-faqs/bloque-faqs.component';

@Component({
  selector: 'app-home-faqs',
  templateUrl: './home-faqs.component.html',
  styleUrls: ['./home-faqs.component.scss'],
  standalone: true,
  imports: [
    SharedModule,
    RouterModule,
    BloqueFaqsComponent
  ]
})

export class HomeFaqsComponent implements OnInit
{
  @Input() plataformaId: string;
  faqs: Faq[];

  constructor() { }

  ngOnInit(): void
  {
    this.getFaqs(this.plataformaId);
  }

  private getFaqs(type: string): void
  {
    const respuestaClass: string = 'p2-regular neutral-800';
    const boldClass: string = 'p2-semibold';
    switch (type)
    {
      case 'VENTURE':
      case 'REALESTATE':
      case 'CREATIVE':
      case 'SEGOFINANCE':
        this.faqs = [
          {
            pregunta: "¿Qué es SEGO Venture?",
            respuesta: `<p class='${respuestaClass}'>SEGO Venture (antes SociosInversores.com) es la línea de inversión en el capital de empresas tecnológicas con alto potencial de crecimiento, supervisada por la Comisión Nacional del Mercado de Valores (CNMV). La inversión se realiza mediante la suscripción de acciones o participaciones sociales de la empresa (Equity Crowdfunding). SEGO Venture, lidera el mercado con más de 180 operaciones realizadas con éxito y la mayor red de inversores privados de España.</p>
            <p class='${respuestaClass}'>Durante sus más de 12 años de vida, los inversores de SEGO Venture han invertido más de 40 Millones de euros en innovación, han creado más de 1000 empleos de forma directa e indirecta y han podido desinvertir consiguiendo importantes plusvalías. Entre estos exits, destacan tres compañías que ya están cotizando en Bolsa como <strong class='${boldClass}'>Energy Solar Tech, Vytrus Biotech y Endurance Motive</strong>.</p>`
          },
          {
            pregunta: "¿Qué es SEGO Real Estate?",
            respuesta: `<p class='${respuestaClass}'>SEGO Real Estate es la plataforma de Crowdlending Inmobiliario líder en países de habla hispana. A través de SEGO Real Estate, los inversores pueden diversificar el riesgo de sus carteras de inversión en el sector inmobiliario, en las mejores oportunidades del mercado que han sido analizadas por nuestros analistas.</p>`
          },
          {
            pregunta: '¿Qué es SEGO Creative?',
            respuesta: `<p class='${respuestaClass}'>SEGO Creative es la línea de financiación de SEGOFINANCE destinada a proyectos audiovisuales que estén desarrollados, producidos y/o coproducidos por empresas de España.</span>`
          },
          {
            pregunta: "¿Qué significa Equity Crowdfunding?",
            respuesta: `<p class='${respuestaClass}'>El <strong class='${boldClass}'>crowdfunding</strong> se define como la aportación de pequeñas cantidades de dinero por parte de muchos inversores con la finalidad de conseguir una suma total de dinero con la que <strong class='${boldClass}'>financiar un proyecto.</strong></p>
            <p class='${respuestaClass}'>
              Existen distintos <strong class='${boldClass}'>tipos de Crowdfunding</strong>, entre ellos se encuentra el <strong class='${boldClass}'>Equity Crowdfunding</strong>, que es en el que el inversor aporta una cantidad de capital a una empresa a cambio de participaciones o acciones de la misma, pasando por tanto a ser socio de la compañía. Este proceso se formalizará siempre ante notario.
            </p>
            <p class='${respuestaClass}'>
              SEGO Venture es un <strong class='${boldClass}'>Proveedor de Servicios de Financiación Participativa</strong> regulada por la <strong class='${boldClass}'>Comisión Nacional del Mercado de Valores (CNMV)</strong> y registrada en la <strong class='${boldClass}'>Autoridad Europea de Supervisión de Valores y Mercados (AEVM)</strong>. Ésto es una garantía para los inversores interesados, ya que les asegura que el proyecto y la ronda de inversión van a seguir una serie de protocolos que han sido validados y que cumplen con todos los requisitos legales pertinentes.
            </p>`
          },
        ]
        break;
      case 'FUNDS':
        this.faqs = [
          {
            pregunta: "¿Qué es SEGO Funds?",
            respuesta: `<p class='${respuestaClass}'>SEGO Funds es una plataforma que permite a cualquier usuario invertir su dinero a través de productos de inversión basados en seguros y planes de pensiones, de alta rentabilidad y muy bajas comisiones.</p>
            <p class='${respuestaClass}'>Somos un Agente de MyInvestor Banco S.A. y Agente de MEDVIDA Partners de Seguros y Reaseguros S.A. (Sociedad Unipersonal). Inscrito con número C0559B87860854 en el Registro de Mediadores de la DGSFP.</p>`
          },
          {
            pregunta: "¿Cómo se puede abrir una cuenta remunerada?",
            respuesta: `
            <p class='${respuestaClass}'>Es un proceso 100 % digital que sólo llevará unos minutos. Se puede abrir la cuenta directamente desde el móvil o PC. Se recomienda hacerlo desde el móvil, ya que la cámara suele ser mejor y la experiencia de usuario será mejor.</p>
            <p class='${respuestaClass}'>Una vez finalizado el proceso, se firmará el contrato con una clave que llegará al móvil y se recibirá un email con los datos de la nueva cuenta y una copia del contrato para su archivo.</p>
            <p class='${respuestaClass}'>En caso de necesitar apoyo durante el proceso, contacta con el 910 005 981.</p>`
          },
          {
            pregunta: "¿Qué es un depósito?",
            respuesta: `<p class='${respuestaClass}'>Es un producto bancario en el que entregamos el dinero a la entidad durante un plazo determinado y a su finalización obtenemos la cantidad entregada más los intereses pactados.</p>`
          },
          {
            pregunta: "¿Qué es una cartera de fondos indexados?",
            respuesta: `<p class='${respuestaClass}'>Es un instrumento de inversión que está compuesto por un conjunto de fondos indexados. Cada uno de estos fondos tiene como objetivo replicar el comportamiento de un índice. La selección de los fondos que integran la cartera se ajusta a un criterio de rentabilidad/riesgo.</p>`
          },
          {
            pregunta: "¿Cómo puedes saber tu nivel de riesgo?",
            respuesta: `<p class='${respuestaClass}'>Para acceder a este servicio es imprescindible realizar un test online que te llevará unos minutos. Este test servirá para determinar tus necesidades y objetivos y asignarte tu perfil de riesgo.</p>`
          }
        ]
        break;
      case 'FACTORING':
        this.faqs = [
          {
            pregunta: "¿Qué es SEGO Factoring?",
            respuesta: `<p class='${respuestaClass}'>SEGO Factoring es el producto de corto plazo y bajo riesgo del Grupo SEGOFINANCE. En Factoring son los inversores particulares los que deciden qué cantidad y en qué operaciones quieren invertir. Para ello, se adquiere un modelo de adelanto de facturas mediante adquisición de créditos que una empresa ostenta frente a un cliente suyo y que se pagarán en un plazo determinado.</p>`
          },
          {
            pregunta: "¿Hay alguna cantidad mínima para empezar a invertir?",
            respuesta: `<p class='${respuestaClass}'>Los inversores podrán hacer un ingreso desde 100 euros. Posteriormente, cada factura tendrá asignada un ticket mínimo que irá desde los 50 euros a los 1.000 euros.</p>`
          },
          {
            pregunta: "¿Qué coste tiene SEGO Factoring para el inversor?",
            respuesta: `<p class='${respuestaClass}'>El servicio para el inversor no tiene ningún coste inicial ni de mantenimiento. La única cuota para el inversor es una comisión a éxito del 20% IVA incluído sobre los beneficios generados, evitando así que la plataforma suponga ningún coste para los inversores. Ver Tarifas y Comisiones.</p>`
          },
          {
            pregunta: "¿Dónde se depositan los fondos?",
            respuesta: `<p class='${respuestaClass}'>Para una mayor transparencia, las inversiones realizadas nunca pasarán por la cuenta de SEGO Factoring, si no que permanecerán en un wallet propiedad de MangoPay, pasarela de pagos registrada y regulada por la Comisión Europea, y que será la propietaria de las cuentas a utilizar en la operativa de SEGO Factoring. En el momento de formalizar la inversión, los fondos se transferirán desde el wallet del inversor a la cuenta de la empresa.</p>`
          }
        ]
        break;

      default:
        break;
    }
  }
}
